import BigEventsPC from './BigEventsPC'
import BigEventsMobile from './BigEventsMobile'

import InfoQService from '@/service/infoq.service.js'

import { mapState } from 'vuex'

export default {
  data: () => ({
    events: []
  }),
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {
    getBigEvents () {
      InfoQService.getBigEvents()
        .then(data => {
          // console.log(data)
          this.events = data.list
        })
        .catch(() => {})
    }
  },
  created () {
    this.getBigEvents()
  },
  render () {
    const props = {
      events: this.events
    }

    if (this.isMobile) {
      return <BigEventsMobile { ...{ props } } />
    } else {
      return <BigEventsPC { ...{ props } } />
    }
  }
}
